import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ExternalLink, Package } from "lucide-react";
import { api, fileUrl, brl } from "../lib/api";

export const AdCarousel = ({ placement, title }) => {
  const [ads, setAds] = useState([]);
  const [i, setI] = useState(0);
  useEffect(() => { api.get("/ads", { params: { placement } }).then((r) => setAds(r.data)).catch(() => {}); }, [placement]);
  useEffect(() => {
    if (ads.length < 2) return undefined;
    const t = setInterval(() => setI((x) => (x + 1) % ads.length), 5000);
    return () => clearInterval(t);
  }, [ads.length]);
  if (!ads.length) return null;
  const ad = ads[i % ads.length];
  const body = (
    <div className="card-x relative overflow-hidden" style={{ aspectRatio: "16 / 5", minHeight: 110 }}>
      {ad.image_path && <img key={ad.id} src={fileUrl(ad.image_path)} alt={ad.title} className="absolute inset-0 h-full w-full object-cover rise" />}
      {(ad.text || !ad.image_path) && (
        <div className="absolute inset-0 flex flex-col justify-end bg-gradient-to-t from-black/80 to-transparent p-4">
          <div className="h-display text-2xl">{ad.title}</div>
          {ad.text && <div className="text-sm text-[#cbd5e1]">{ad.text}</div>}
        </div>
      )}
      {ad.link && <ExternalLink className="absolute right-3 top-3 h-4 w-4 text-white/80" />}
    </div>
  );
  return (
    <div data-testid={`ads-${placement}`}>
      {title && <div className="eyebrow mb-3">{title}</div>}
      {ad.link ? <a href={ad.link} target="_blank" rel="noreferrer" data-testid={`ad-${ad.id}`}>{body}</a> : <div data-testid={`ad-${ad.id}`}>{body}</div>}
      {ads.length > 1 && (
        <div className="mt-2 flex justify-center gap-1.5">
          {ads.map((a, k) => <button key={a.id} data-testid={`ad-dot-${k}`} onClick={() => setI(k)} className={`h-1.5 rounded-full transition-[width,background-color] ${k === i % ads.length ? "w-6 bg-[#E4F222]" : "w-1.5 bg-[#232B3E]"}`} />)}
        </div>
      )}
    </div>
  );
};

export const ProductShowcase = ({ onBuy }) => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/public/products").then((r) => setItems(r.data)).catch(() => {}); }, []);
  if (!items.length) return null;
  return (
    <div data-testid="login-products-showcase">
      <div className="mb-3 flex items-end justify-between">
        <div><div className="eyebrow">Loja oficial</div><div className="h-display text-3xl">Vista o <span className="text-[#E4F222]">circuito</span></div></div>
        <button onClick={onBuy} data-testid="showcase-login-btn" className="text-xs font-semibold text-[#E4F222]">Entre para comprar</button>
      </div>
      <div className="no-scrollbar flex snap-x gap-3 overflow-x-auto pb-1">
        {items.map((p) => (
          <button key={p.id} onClick={onBuy} data-testid={`showcase-product-${p.id}`} className="card-x card-hover w-40 shrink-0 snap-start overflow-hidden text-left sm:w-52">
            <div className="aspect-square bg-[#0B0E14]">
              {p.images?.[0] ? <img src={fileUrl(p.images[0])} alt={p.name} className="h-full w-full object-cover" /> : <div className="flex h-full items-center justify-center"><Package className="h-8 w-8 text-[#232B3E]" /></div>}
            </div>
            <div className="p-3">
              <div className="text-[10px] uppercase tracking-widest text-[#64748B]">{p.category}</div>
              <div className="truncate text-sm font-semibold">{p.name}</div>
              <div className="flex items-center justify-between"><span className="font-display text-lg font-bold text-[#E4F222]">{brl(p.price)}</span><span className="rounded-full bg-[#E4F222] px-2 py-0.5 text-[10px] font-bold text-black">Comprar</span></div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export const ProductCarousel = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/products").then((r) => setItems(r.data.filter((p) => p.active))); }, []);
  if (!items.length) return null;
  return (
    <div data-testid="home-products-carousel">
      <div className="mb-3 flex items-center justify-between">
        <div className="eyebrow">Loja oficial</div>
        <Link to="/app/loja" className="text-xs font-semibold text-[#E4F222]" data-testid="home-store-link">Ver loja</Link>
      </div>
      <div className="no-scrollbar flex snap-x gap-3 overflow-x-auto pb-1">
        {items.map((p) => (
          <Link key={p.id} to="/app/loja" data-testid={`home-product-${p.id}`} className="card-x card-hover w-40 shrink-0 snap-start overflow-hidden sm:w-48">
            <div className="aspect-square bg-[#0B0E14]">
              {p.images[0] ? <img src={fileUrl(p.images[0])} alt={p.name} className="h-full w-full object-cover" /> : <div className="flex h-full items-center justify-center"><Package className="h-8 w-8 text-[#232B3E]" /></div>}
            </div>
            <div className="p-3">
              <div className="truncate text-sm font-semibold">{p.name}</div>
              <div className="font-display text-lg font-bold text-[#E4F222]">{brl(p.price)}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};
